import { updateSectionData } from './utils';

import axios from 'axios';
import { getExpertise } from '../formElements/Expertise/utils';
import { runAxios } from './axios';
import { fillInBulletsFromAI } from '../formElements/Bullets/Navigation/utils';
import { getUsefulVars } from './helpers';
import { handleSubmit } from '../components/ProgressiveFormStepper/utils';
import { getComputerSkills } from '../formElements/ComputerSkills/utils';
import { getInterview } from '../formSections/Interview/utils';


function waitForElement(stateProps) {
  if (stateProps.loadingSkills) {
    return null;
  } else {
    setTimeout(function() {
      waitForElement(stateProps);
    }, 4000);
  }
}


export const onPreview = (checkAI = false, formikProps, stateProps, uri, editableIndex = 0, sectionType = 'section') => {
  onLink(checkAI = false, formikProps, stateProps, uri, editableIndex = 0, sectionType = 'section');
};

export const onLink = (checkAI = false, formikProps, stateProps, uri, editableIndex = 0, sectionType = 'section', resumeIndex = '', completeProps = null) => {
  resumeIndex = resumeIndex === '' ? stateProps.sectionData.resumeIndex : resumeIndex;
  //bad hack.  preview needs to become part of state.  Need to work out how to transfer a urlParam to state and
  //and then extinguish. This takes care of it because onlink
  //window.preview = 0;
  if (checkAI) {
    //ALERT
    /*
    const pe = stateProps.dataToSave.saved.resumes[resumeIndex]['professifonal-experience'];
    if (uri === 'career-profile' && (typeof pe === 'undefined' || pe.length < 3)) {
      stateProps.onCareerSummaryOpen();
    }*/
    if (uri === 'career-profile') {
      const preview = stateProps.sectionData.sectionName === 'preview' ? 1 : 0;
      stateProps.setStep(stateProps.step = 0);

      updateSectionData({
        sectionName: uri,
        sectionType: sectionType,
        preview: preview,
        sectionIndex: editableIndex,
      }, stateProps);
      stateProps.setSortableList([]);
      stateProps.setEditableIndex(editableIndex);
      //resumeIndex can be factored out
      save(stateProps, resumeIndex);
    }
  } else {
    const resume = stateProps.dataToSave.saved.resumes[resumeIndex];
    if (uri === 'technical-skills') {
      if (resume.regenExpertise === undefined || resume.regenExpertise) {
        getExpertise(stateProps, '', resumeIndex, 'section');
      }
    }
    if (uri === 'professional-experience' && resume['professional-experience'] !== undefined && resume['professional-experience'].length > 0) {
      editableIndex = editableIndex;
    }
    if (uri === 'computer-skills') {
      if (resume.regenComputerSkills === undefined || resume.regenComputerSkills) {
        getComputerSkills(stateProps, '', resumeIndex, 'section');
      }
    }
    /*
    if (uri === 'interview-coach' && completeProps !== null) {
      getInterview(completeProps);
    }*/
    stateProps.setStep(stateProps.step = 0);

    const preview = stateProps.sectionData.sectionName === 'preview' ? 1 : 0;
    /*
    let parsed = false;
    if(uri === 'parser') {
      parsed = true;
    }*/
    updateSectionData({
      sectionName: uri,
      sectionType: sectionType,
      preview: preview,
      // parsed:uri === parsed,
      resumeIndex: resumeIndex,
      sectionIndex: editableIndex,
    }, stateProps);
    stateProps.setSortableList([]);
    stateProps.setEditableIndex(editableIndex);
    //resumeIndex can be factored out
    save(stateProps, resumeIndex);
    if (uri === 'career-profile') {
      const testPE = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'];
      if (typeof testPE === 'undefined' || testPE.length < 2) {
        stateProps.onCareerSummaryOpen();
      }
    }
    if (uri === 'professional-experience') {
      stateProps.onCareerSummaryClose();
    }
  }
};
export const isMultiSection = (props) => {
  const sTypes = {
    'start': 'start',
    'contact': 'contact',
    'computer-skills': 'computer-skills',
    'career-profile': 'career-profile',
    'technical-skills': 'technical-skills',
    'parse-letter': 'parse-letter',
    'survey': 'survey',
    'new-aptitude': 'new-aptitude',
    'interview-coach-home': 'interview-coach-home',
    'interview-you': 'interview-you',
    'interview-questions': 'interview-questions',
    'job-posting': 'job-posting',
  };
  const sectionName = props.stateProps.sectionData.sectionName;
  return typeof sTypes[sectionName] === 'undefined';
};

/**
 *
 * @param props
 * @param formikProps
 * @param resumeIndex
 * @param resume
 */
export const setResume = (props, resumeIndex) => {

  const resume = props.stateProps.dataToSave.saved.resumes[resumeIndex];
  const parsed = resume.parsed !== undefined ? resume.parsed : false;
  const sectionName = parsed ? 'menu' : 'parser';
  props.stateProps.setRegenCS(true);
  props.stateProps.setResumeOpen(false);
  if (props.formikProps.values.jobSeekerData[resumeIndex]['industry'] && props.formikProps.values.jobSeekerData[resumeIndex]['job_title']) {

    const resumeIndustryName = props.stateProps.dataToSave.saved.resumes[resumeIndex].industry;
    resume['resume_date'] = new Date();

    //getOptions(props, '', resumeIndex, 'section');
    updateSectionData({
      resumeIndex: resumeIndex, //set to the resume clicked
      resumeIndustryName: resumeIndustryName,
      sectionName: sectionName,
      parsed: parsed,
      sectionType: 'section',
    }, props.stateProps);
    props.stateProps.setFocus({});
    props.stateProps.setSortableList([]);
    props.stateProps.setEditableIndex(0);
    props.stateProps.setASError({});
  } else {
    setIndustryJobTitleError(props.stateProps, props.formikProps, resumeIndex);
  }


};
export const setIndustryJobTitleError = (stateProps, formikProps, index) => {

  const error = stateProps.asError;
  if (!formikProps.values.jobSeekerData[index]['industry']) {
    error.industry = 'REQUIRED *';
    stateProps.setASError(error);
  } else {
    delete error.industry;
    stateProps.setASError(error);
  }
  if (!formikProps.values.jobSeekerData[index]['job_title']) {
    const error = stateProps.asError;
    error.job_title = 'REQUIRED *';
    stateProps.setASError(error);
  } else {
    delete error.job_title;
    stateProps.setASError(error);
  }
  stateProps.setCounter(stateProps.counter + 1);
};


export const generateQuestionsSkipCallback = (result, args) => {
  const props = args.props;
  const formikProps = props.formikProps;
  const stateProps = props.stateProps;
  const industryQuestions = result.data;
  industryQuestions.forEach((question) => {
    question.isIndustry = true;
    //question.qid = 'GEN'+Math.random().toString(36).substr(2, 9);
  });
  stateProps.dataToSave.industry.other = {};
  stateProps.dataToSave.industry.other.questions = industryQuestions;

  fillInBulletsFromAI(props, args.jobSeekerData, args.target_job_title, args.job_title, true, 'last');
  onSubmit(formikProps, stateProps);
};
export const generateQuestionsCallback = (result, args) => {
  const formikProps = args.props.formikProps;
  const stateProps = args.props.stateProps;

  const industryQuestions = result.data;
  const sectionIndex = stateProps.sectionData.sectionIndex;
  industryQuestions.forEach((question) => {
    question.isIndustry = true;
    //question.qid = 'GEN'+Math.random().toString(36).substr(2, 9);
  });
  stateProps.dataToSave.industry.other = {};
  stateProps.dataToSave.industry.other.questions = industryQuestions;
  /*
    if (oldIndustry !== industry) {
      industryReset(formikProps, indList, sectionIndex);
    }*/
  onSubmit(formikProps, stateProps);
  //f(!goToFinalStep) {
  updateSectionData({
    sectionType: 'industry',
    industryType: 'other',
    indIndex: sectionIndex,

  }, stateProps);
  stateProps.setSpinnerImage('default.gif');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
  handleEditable(stateProps, stateProps.sectionData.sectionIndex, 0);
};

export const getJobExperience = (jobSeekerData) => {
  const startMonth = typeof jobSeekerData['start_month'] !== 'undefined' ? jobSeekerData['start_month'] : '';
  const startYear = typeof jobSeekerData['start_year'] !== 'undefined' ? jobSeekerData['start_year'] : '';
  const startDate = startMonth !== '' && startYear !== '' ? 'Job Start Date: ' + startMonth + '/' + startYear + ' ' : '';
  const endMonth = typeof jobSeekerData['end_month'] !== 'undefined' ? jobSeekerData['end_month'] : '';
  const endYear = typeof jobSeekerData['end_year'] !== 'undefined' ? jobSeekerData['end_year'] : '';
  const endDate = startMonth !== '' && endYear !== '' ? 'Job End Date: ' + endMonth + '/' + endYear + ' ' : '';
  const jobLocation = typeof jobSeekerData['city'] !== 'undefined' && typeof jobSeekerData['state'] !== 'undefined' ? 'Job Location: ' + jobSeekerData['city'] + ', ' + jobSeekerData['state'][0] : '';
  return startDate + ' ' + endDate + ' ' + jobLocation;
};
/**
 *
 * @param formikProps
 * @param stateProps
 */
export const personalizeBullets = (props, callback = generateQuestionsCallback) => {
  let step = 0;
  const uv = getUsefulVars(props);
  const sectionIndex = uv.stateProps.sectionData.sectionIndex;
  const jobSeekerData = uv.formikProps.values.jobSeekerData[sectionIndex];
  const industry = uv.formikProps.values.jobSeekerData[sectionIndex]['industry'];
  const oldIndustry = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['professional-experience'][sectionIndex]['industry'];
  const jobTitle = uv.formikProps.values.jobSeekerData[sectionIndex]['job_title'];
  const notes = uv.formikProps.values.jobSeekerData[sectionIndex]['notes'];

  const jobExperience = getJobExperience(jobSeekerData);
  const targetJobTitle = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['job_title'];
  const targetIndustry = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['industry'][0];
  if (industry && jobTitle) {
    let indList = null;
    let industryQuestions = null;
    if (typeof industry !== 'undefined') {
      //get industry questions? list or if this isn't a regular industry get "other questions"
      const url = uv.stateProps.domain + '/wp-json/rsworks/v1/generateQuestions';


      const request = {
        jobTitle: jobTitle,
        industry: industry,
        existing: jobSeekerData['existing'],
        notes: notes,
        targetJobTitle: targetJobTitle,
        targetIndustry: targetIndustry,
        jobExperience: jobExperience,
      };
      const args = {
        props: props,
        message: 'Generate questions from AI',
      };
      uv.stateProps.setSpinnerMessage('I see career fulfillment in your future...');
      uv.stateProps.setSpinnerImage('next.gif');
      uv.stateProps.onSpinnerOpen();

      runAxios(url, request, callback, args);
    }
    if (industryQuestions !== null) {
      industryQuestions.forEach((question) => {
        question.isIndustry = true;
      });

      if (oldIndustry !== industry) {
        industryReset(uv.formikProps, indList, sectionIndex);
      }
      onSubmit(uv.formikProps, uv.stateProps);
      //f(!goToFinalStep) {

      updateSectionData({
        sectionType: 'industry',
        industryType: industry,
        indIndex: sectionIndex,

      }, uv.stateProps);
      handleEditable(uv.stateProps, sectionIndex, step);

//      return fetchBullets(uv.formikProps, uv.stateProps, sectionIndex, step);
      //}
    } else {
      //need error handling here.
    }
  } else {
    setIndustryJobTitleError(uv.stateProps, uv.formikProps, sectionIndex);
  }
};
/**
 *
 * @param formikProps
 * @param stateProps
 * @param goToFinalStep
 * @returns {boolean|void}

 export const moreDetails = (formikProps, stateProps) => {
 stateProps.onSpinnerOpen();
 let step = 0;
 const resumeIndex = stateProps.sectionData.resumeIndex;
 const indIndex = stateProps.sectionData.indIndex;
 const industry = formikProps.values.jobSeekerData[indIndex]['industry'];
 const oldIndustry = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'][indIndex]['industry'];
 const jobTitle = formikProps.values.jobSeekerData[indIndex]['job_title'];
 if ( industry && jobTitle) {
 let indList = null;
 let industryQuestions = null;
 if (typeof industry !== 'undefined') {
 //get industry questions? list or if this isn't a regular industry get "other questions"
 if (typeof stateProps.dataToSave.industry[industry] !== 'undefined') {
 industryQuestions =  stateProps.dataToSave.industry[industry]['questions'];
 } else {
 industryQuestions =  stateProps.dataToSave.industry['other']['questions'];
 }
 }
 if(industryQuestions !== null ) {
 industryQuestions.forEach((question) => {
 question.isIndustry = true;
 });
 } else {
 //need error handling here.
 }
 if (oldIndustry !== industry) {
 industryReset(formikProps, indList, indIndex);
 }
 onSubmit(formikProps, stateProps);
 //f(!goToFinalStep) {
 return fetchBullets(formikProps, stateProps, indIndex, step);
 //}
 } else {
 return false;
 //need error handling here.
 }
 };*/
export const handleRemove = (formikProps, stateProps, index) => {
  const uv = getUsefulVars({ formikProps, stateProps });
  uv.formikProps.values.jobSeekerData.splice(index, 1);
  if (uv.formikProps.values.jobSeekerData.length === 0) {
    const sectionName = stateProps.sectionData.sectionName;

    delete (stateProps.dataToSave.saved.resumes[uv.resumeIndex][sectionName]);
  }
  onSubmit(formikProps, stateProps);
};
export const handleEditable = (stateProps, index, step = 0) => {
  stateProps.setStep(step);
  stateProps.setEditableIndex(index);
};
export const industryReset = (formikProps, indList, index) => {
  indList.forEach((question) => {
    question.isIndustry = true;
    formikProps.values.jobSeekerData[index][question.qid] = '';
  });
};
export const onSubmit = (formikProps, stateProps, sectionName = '') => {
  sectionName = sectionName === '' ? stateProps.sectionData.sectionName : sectionName;
  let newData = stateProps.dataToSave.saved;
  if (sectionName === 'resumes') {

    const resumeIndex = stateProps.sectionData.resumeIndex > formikProps.values.jobSeekerData.length - 1
      ? formikProps.values.jobSeekerData.length - 1
      : stateProps.sectionData.resumeIndex;
    updateSectionData({ resumeIndex: resumeIndex }, stateProps);

    newData['resumes'][resumeIndex]['guid'] = stateProps.sectionData.guid;
    newData['resumes'][resumeIndex] = formikProps.values.jobSeekerData[resumeIndex];
    if (typeof formikProps.values.jobSeekerData[resumeIndex]['Test1'] !== 'undefined') {
      newData['resumes'][resumeIndex]['industry'] = formikProps.values.jobSeekerData[resumeIndex]['Test1'];
    }
  } else {
    if (formikProps.values.jobSeekerData.length > 0) {
      if (!(formikProps.values.jobSeekerData.length === 1 && Object.keys(formikProps.values.jobSeekerData[0]).length === 0)) {
        const resumeIndex = stateProps.sectionData.resumeIndex;
        newData['resumes'][resumeIndex]['guid'] = stateProps.sectionData.guid;
        newData['resumes'][resumeIndex][sectionName] = formikProps.values.jobSeekerData;
      }
    }
    stateProps.setDataToSave({ saved: newData, industry: stateProps.dataToSave.industry });
    stateProps.isDataSaved(true);
  }
}


  export const onDownloadCoverLetter = async (e, formikProps, stateProps, resumeIndex) => {
    const resume = stateProps.dataToSave.saved.resumes[resumeIndex];

    const pe = resume['professional-experience'];
    if (typeof pe === 'undefined' || pe.length < 2) {
      stateProps.onCareerSummaryOpen();
    }
    const start = resume.start;
    if (typeof start === 'undefined' || typeof start[0]['template_id'] === 'undefined') {
      stateProps.setMessageModal(true);
      updateSectionData({ modalMessage: 'Resume not downloaded. You must select a template.' }, stateProps);
      stateProps.onOpen();

    } else {
      onLink(false, formikProps, stateProps, 'preview-letter', 0, 'section');
    }
  };

  export const onDownload = async (e, formikProps, stateProps, resumeIndex) => {
    const resume = stateProps.dataToSave.saved.resumes[resumeIndex];

    const pe = resume['professional-experience'];
    if (typeof pe === 'undefined' || pe.length < 2) {
      stateProps.onCareerSummaryOpen();
    }
    const start = resume.start;
    if (typeof start === 'undefined' || typeof start[0]['template_id'] === 'undefined') {
      stateProps.setMessageModal(true);
      updateSectionData({ modalMessage: 'Resume not downloaded. You must select a template.' }, stateProps);
      stateProps.onOpen();

    } else {
      onLink(false, formikProps, stateProps, 'download', 0, 'section');
    }
  };
  export const downloadCoverLetter = async (props) => {
    const uv = getUsefulVars(props);

    uv.stateProps.setSpinnerMessage('Amazing job offers will be landing in your inbox!');
    uv.stateProps.setSpinnerImage('download.gif');
    uv.stateProps.onSpinnerOpen();

    window.removeEventListener('beforeunload', unloadCallback);
    onSubmit(uv.formikProps, uv.stateProps);
    const url = uv.stateProps.domain + '/wp-json/rsworks/v1/downloadLetter';
    const dataToSend = JSON.stringify(uv.stateProps.dataToSave.saved.resumes);

    const request = { survey: dataToSend, resumeIndex: uv.resumeIndex, guid: uv.stateProps.sectionData.guid };
    const result = await axios.post(url, request);
    let link = document.createElement('a');
    link.href = result.data;
    link.download = 'file.pdf';
    link.dispatchEvent(new MouseEvent('click'));
    window.addEventListener('beforeunload', unloadCallback);
    uv.stateProps.setMessageModal(true);
    updateSectionData({
      modalMessage: 'You\'ve downloaded your new cover letter! Check your download bar in your browser or downloads folder to view it.',
      fileUrl: result.data,
    }, uv.stateProps);
    uv.stateProps.setSpinnerImage('preview.gif');
    uv.stateProps.setSpinnerMessage('Wishing you an inbox full of amazing job offers!');
    uv.stateProps.onSpinnerClose();

    uv.stateProps.onOpen();
  };
  export const download = async (props) => {
    const uv = getUsefulVars(props);
    if (uv.resume.download === undefined) {
      alert('Please generate a career summary before download.');
      return null;
    }
    const start = uv.resume.start;
    if (start === undefined || start[0] === undefined || start[0].template_id === undefined) {
      alert('Please select a template before download.');
      return null;
    }
    uv.stateProps.setisai(false);
    uv.stateProps.setSpinnerMessage('Amazing job offers will be landing in your inbox!');
    uv.stateProps.setSpinnerImage('download.gif');
    uv.stateProps.onSpinnerOpen();

    window.removeEventListener('beforeunload', unloadCallback);
    onSubmit(uv.formikProps, uv.stateProps);
    const url = uv.stateProps.domain + '/wp-json/rsworks/v1/downloadSurvey';
    const dataToSend = JSON.stringify(uv.stateProps.dataToSave.saved.resumes);

    const request = { survey: dataToSend, resumeIndex: uv.resumeIndex, guid: uv.stateProps.sectionData.guid };
    const result = await axios.post(url, request);
    let link = document.createElement('a');
    link.href = result.data;
    link.download = 'file.pdf';
    link.dispatchEvent(new MouseEvent('click'));
    window.addEventListener('beforeunload', unloadCallback);
    uv.stateProps.setMessageModal(true);
    updateSectionData({
      modalMessage: 'You\'ve downloaded your new resume! Check your download bar in your browser or downloads folder to view it.',
      fileUrl: result.data,
    }, uv.stateProps);
    uv.stateProps.setSpinnerImage('preview.gif');
    uv.stateProps.setSpinnerMessage('Wishing you an inbox full of amazing job offers!');
    uv.stateProps.onSpinnerClose();

    uv.stateProps.onOpen();
  };
  export const unloadCallback = (event) => {
    event.preventDefault();
    return event.returnValue = '';
  };
  export const save = async (stateProps, resumeIndex) => {

    const formData = new FormData();
    resumeIndex = stateProps.resumeToDelete === -1 ? resumeIndex : stateProps.resumeToDelete;
    const savedResume = stateProps.dataToSave.saved.resumes[resumeIndex];
    stateProps.setResumeToDelete(-1);
    if (savedResume !== undefined && savedResume.parser !== undefined && typeof savedResume.parser[0].P2 !== 'undefined') {
      formData.append('file', savedResume.parser[0].P2);
      // why is this here
      savedResume.resume_date = new Date().getTime();
    }
    const url = stateProps.domain + '/wp-json/rsworks/v1/saveSurvey';
    const dataToSend = JSON.stringify(stateProps.dataToSave.saved.resumes);
    formData.append('survey', dataToSend);
    formData.append('resumeIndex', resumeIndex);
    formData.append('guid', [stateProps.sectionData.guid]);

    /*  const request = {
        survey: dataToSend,
        resumeIndex: resumeIndex, guid: [stateProps.sectionData.guid] }; */
    await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };
  export const onSave = async (e, formikProps, stateProps, resumeIndex) => {
    stateProps.setMessageModal(true);
    updateSectionData({ modalMessage: 'Your new resume has been saved. You can find it in on the My Resumes page.' }, stateProps);
    stateProps.onOpen(e);

    onSubmit(formikProps, stateProps);
    await save(stateProps, resumeIndex);
  };
  export const deleteResume = (props, index) => {
    if (index > 0) {
      const uv = getUsefulVars(props, index);
      const oldResumes = uv.stateProps.dataToSave.saved;
      oldResumes.resumes.splice(index, 1);
      const newResumes = { saved: oldResumes, industry: uv.stateProps.dataToSave.industry };
      props.stateProps.setResumeToDelete(index);

      uv.stateProps.setDataToSave(newResumes);
      uv.formikProps.values.jobSeekerData = newResumes.saved.resumes;
      handleSubmit(props, 'resumes');
    } else {
      alert('cannot delete original resume');
    }
  };

  export const getResumeOrSectionIndex = (stateProps, formikProps) => {
    let sectionIndex = 0;
    if (stateProps.sectionData.sectionType === 'section') {
      if (stateProps.sectionData.sectionName === 'resumes') {
        sectionIndex = stateProps.sectionData.resumeIndex;//getSectionIndex(stateProps, formikProps, stateProps.sectionData.resumeIndex);
      } else {
        sectionIndex = stateProps.sectionData.sectionIndex;//getSectionIndex(stateProps, formikProps, stateProps.sectionData.sectionIndex);
      }
    } else {
      if (stateProps.sectionData.sectionType === 'industry') {
        // sectionIndex = stateProps.sectionData.indIndex;
      }
    }
    return sectionIndex;
  };
  export const handleAdd = (formikProps, stateProps, secPart) => {
    const jobSeekerData = formikProps.values.jobSeekerData;
    const newSectionIndex = jobSeekerData.length;
    updateSectionData({ sectionIndex: newSectionIndex }, stateProps);

    const newPart = {};
    jobSeekerData.push(newPart);
    onSubmit(formikProps, stateProps);
    stateProps.setEditableIndex(jobSeekerData.length - 1);
    stateProps.setStep(0);
  };

  export const canSubmit = (props) => {
    //WTH
    return true;
  };